import * as React from 'react';
import styled from 'styled-components';
import { Breakpoints } from '@volkswagen-onehub/components-core';
import { useState } from 'react';
import { useTrackingService } from '@/contexts/TrackingServiceContext';
import { TrackingEvent } from '@/util/tracking/definitions';
import { ClusterButton } from './ClusterButton';
import { CLUSTER_DATA } from './ClusterButton.types';
import { CLUSTER_BUTTON_TYPES } from '@/enums/ClusterButton';

interface ClusteredButtonContainerProps {
  tabs: CLUSTER_DATA[];
  activeTab: CLUSTER_BUTTON_TYPES;
  onTabChange: (label: CLUSTER_BUTTON_TYPES) => void;
  backgroundColor?: string;
}

export const CTAClusterContainer = styled.div<{ backgroundColor?: string }>`
  display: flex;
  gap: ${({ theme }) => theme.size.static150};
  pointer-events: all;
  width: fit-content;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? theme.colors.switcher.on.default : 'white'};
  border-radius: ${({ theme }) => theme.size.static150};
  padding: ${({ theme }) => `${theme.size.static100} ${theme.size.static150}`};

  @media (min-width: ${Breakpoints.b960}px) {
    background-color: white;
    opacity: 0.95;
    border-radius: ${({ theme }) => theme.size.static150};
    padding: ${({ theme }) => `${theme.size.static150} ${theme.size.static200}`};
  }
`;

export const ClusteredButtonContainer = ({
  tabs,
  activeTab,
  onTabChange,
  backgroundColor,
}: ClusteredButtonContainerProps): React.JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<CLUSTER_BUTTON_TYPES>(activeTab);
  const trackingService = useTrackingService();

  const handleTabClick = (label: CLUSTER_BUTTON_TYPES, ariaLabel: string) => {
    setActiveIndex(label);
    onTabChange(label);
    trackingService.track(TrackingEvent.VWBasicButtonClick, {
      link: { url: ariaLabel, name: label },
      eventInfo: { contentId: `clicked button: ${ariaLabel}-${label}` },
    });
  };

  return (
    <CTAClusterContainer backgroundColor={backgroundColor} data-testid="cluster-button-container">
      {tabs.map((tab: CLUSTER_DATA) => (
        <ClusterButton
          data-testid={`cluster-button-${tab.name}`}
          key={tab.name}
          ariaLabel={tab.ariaLabel}
          active={activeIndex === tab.name}
          handleClick={() => handleTabClick(tab.name, tab.ariaLabel)}
          icon={tab.icon}
        />
      ))}
    </CTAClusterContainer>
  );
};
